import FormAssets from './form-assets';
import DatePicker from './date-picker';
import DropdownMenu from './dropdown';

/**
 * FORM.JS
 */
export default class Form {

    static init() {
        return new Form();
    }

    constructor() {
        DatePicker.init();
        DropdownMenu.init();
        FormAssets.init();
        window.form = this.alpineFormLogic;
    }

    initForm(form) {
        if (!form)
            return;

        FormAssets.init(form);
    }

    alpineFormLogic() {
        return {
            form: null,
            formErrors: {},
            loading: false,
            formSucceeded: false,
            formFailed: false,
            requiredFieldsEmpty: false,

            get formData() {
                let formData = new FormData();

                new FormData(this.form).forEach((value, key) => {
                    if (value)
                        formData.append(key, value);
                });

                return formData;
            },

            get showSuccessMessage() {
                return !this.loading && this.formSucceeded;
            },

            get showErrorMessage() {
                return !this.loading && this.formFailed;
            },

            get showFieldsMissingMessage() {
                return this.requiredFieldsEmpty;
            },

            get redirect() {
                let input = this.form.querySelector('input[name="redirect_uri"]');
                return input ? input.value : null;
            },

            initForm(parentElement) {
                this.form = parentElement.querySelector('form');
                this.form.addEventListener('submit', (event) => {
                    event.preventDefault();
                    this.submitData();
                });
            },

            reset() {
                this.form.reset();
                this.form.querySelectorAll('input[type="file"]').forEach((input) => {
                    input.value = null;
                    input.setAttribute('value', null);
                    input.dispatchEvent(new Event('change'));
                });
            },

            submitData() {
                this.loading = true;
                this.formSucceeded = false;
                this.formFailed = false;
                this.requiredFieldsEmpty = false;
                this.formErrors = {};

                fetch(this.form.action, {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: this.formData
                })
                    .then((response) => {
                        if (![200, 400, 422].includes(response.status))
                            throw 'Form error';
                        return response.json();
                    })
                    .then(data => {
                        if (data && data.error) {
                            this.formErrors = data.error;
                            this.requiredFieldsEmpty = true;
                        } else {
                            if (this.redirect) {
                                window.location.href = this.redirect;
                                return;
                            }
                            this.formSucceeded = true;
                            this.reset();
                        }
                    })
                    .catch((error) => {
                        this.formSucceeded = false;
                        this.formFailed = true;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        }
    }
}